export interface TransformationContext<TInput> {
  /**
   * The input to pass to the transformation evaluator
   */
  input: TInput;
}

export interface TransformationEvaluator<TInput> {
  /**
   * Evaluate a transformation
   * @param context The evaluation context
   */
  evaluate: (context: TransformationContext<TInput>) => Promise<unknown>;
}
